"use client";

// Persistent floating chat entry on every page (Play 3 of the AI Astrologer
// prominence audit). Hidden on /free-kundali/, /ai-astrologer/, /free-astrology-chat/
// where InlineChatPreview / KundaliResult.ChatPanel already render the chat
// inline — a sticky pill on top of those would be redundant noise.

import Link from "next/link";
import { usePathname } from "next/navigation";

import { shouldShowStickyChatButton } from "@/lib/global-overlays";
import { safeSessionSet } from "@/lib/browser-storage";

export default function StickyChatButton() {
  const pathname = usePathname();
  if (!shouldShowStickyChatButton(pathname)) return null;

  function handleClick() {
    try {
      safeSessionSet("seo_entry_path", pathname || "/");
    } catch {
      // Best-effort context handoff.
    }
    void import("@/lib/analytics-events").then(({ trackEvent }) => {
      trackEvent("sticky_chat_button_clicked", {
        source_path: pathname || "/",
      });
    });
  }

  return (
    <Link
      href="/free-kundali/"
      prefetch={false}
      onClick={handleClick}
      aria-label="Ask the AI Jyotishi"
      className="fixed bottom-[76px] right-4 z-40 flex items-center gap-2 rounded-full px-4 py-3 text-[13px] font-semibold shadow-lg transition hover:scale-105 sm:bottom-6"
      style={{
        background: "var(--ish-accent)",
        color: "#fff",
        boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
      }}
    >
      <span aria-hidden className="text-[16px]">
        ॐ
      </span>
      <span className="hidden sm:inline">Ask Pandit Aaditya</span>
      <span className="sm:hidden">Ask Jyotishi</span>
    </Link>
  );
}
